import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.link.js";
import extend from 'lodash-es/extend';
var MINIPTOGRAM_TYPE = {
  release: 0,
  dev: 1,
  preview: 2
};
var VIP_MINIPTOGRAM_ID = 'gh_3425e2640149'; // 腾讯视频VIP小程序的原始ID

function getVideoShareInfo(info) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (!info) {
    throw Error('【设置分享】缺少分享信息');
  } // isShareImageOnly 代表是否传单图 而不是链接


  var shareConfig = {
    "title": info.title,
    "subTitle": info.content,
    "singleTitle": from === 'weibo' && info.weiboContent ? info.weiboContent : info.singleTitle ? info.singleTitle : info.title + '。' + info.content,
    "content": info.content,
    "contentTail": from === 'weibo' && info.weiboContent ? info.weiboContent : info.singleTitle ? info.singleTitle : info.title + '。' + info.content,
    "imageUrl": info.img,
    "imgbase64String": info.isShareImageOnly ? info.imgbase64 : null,
    // "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAoCAMAAAB0DnycAAAAIGNIUk0AAHomAACAhAAA+gAAAIDoAAB1MAAA6mAAADqYAAAXcJy6UTwAAAA2UExURf///wAAAP8AoP8AoP8AoP8AoP8AoP8AoP8AoP8AoP8AoP8AoP8AoP8AoP8AoP8AoP8AoP///4qad6gAAAAQdFJOUwAAIjOZ7hF3iMzdqrtmVUR/C8duAAAAAWJLR0QAiAUdSAAAAa5JREFUSMftlN2WgyAMhPkRJIjg+z/tkiBs1GD3ds/pXFRa7SdkJlHqq38oY5/SXcvhDq/1Gn61GBEDx1OxY7b6pV4cv5lEjBMwrmMcrf3l5iZR/PG2m4pJWhvcQzvRG8ZpP6R3fPKk+LbO9ZLp6TJWN+EjoJnWjoEYI74jRiyfp6fxHUXC8JePqmZ9KQhh/L7v2Q3gTfivnWPgicFCq9C/TP3OHEMvxIWxBg9VrKk/gTK9/FO/PaPQJvoPcfhd7Vk20j71W90wPDa1/BbP/aEV6LhcDIPIZFM4LpJKnKX08dg8JRke5hizxrOon3eDfi8lnyrFutO5dfwtoN91DtSI55lTZCkvMdwwefR3arbaqd9Kio07zmqT30i34bW/lZJiYwzGpvY6tuM+qi36bVu65dhc+jvMbWp+bxxTGAYzteIgJXfidGTVgKNRHJNZbHKrcGoYvBzyHCa/C8cEhkGzTBukSq0v7U1GwcIUe8PbXGjMUIVgpF2e52La2bQ5/V4K5RA/1pnfD/keQ8Lk3g6hbUkaxRukh4AwGe9ANcongFiXATsQEsjH+uqrv+oHuV8wbxueL8EAAAAASUVORK5CYII=",
    "isShareImageOnly": !!info.isShareImageOnly,
    "url": info.link || window.location.href,
    "picList": [],
    // imgUrl, thumbUrl
    "shareDokiInfo": {
      "dokiId": '' + info.dokiId,
      "shareContent": info.content,
      "shareUrlInfo": {
        "url": info.link || window.location.href,
        "urlTitle": info.title,
        "linkImgUrl": info.img
      }
    },
    "dokiId": '' + info.dokiId,
    "shareContent": info.content,
    "shareUrlInfo": {
      "url": info.link || window.location.href,
      "urlTitle": info.title,
      "linkImgUrl": info.img
    }
  };

  if (!shareConfig.isShareImageOnly) {
    delete shareConfig.imgbase64String;
  }

  return shareConfig;
}

function getShare2WeixinInfo(info) {
  var shareConfig = getVideoShareInfo(info); // 分享小程序参数设置

  var miniProgramType = MINIPTOGRAM_TYPE[info.miniProgramType];

  if (miniProgramType >= 0) {
    if (!info.miniProImg || !info.miniProBtn) {
      //miniProImg和miniProBtn为小程序内活动展示图，小程序内取用
      throw Error('【设置分享】分享小程序时活动背景图片和按钮图片不能为空');
    }

    if (!/^(http|https:)/.test(info.miniProImg) || !/^(http|https:)/.test(info.miniProBtn)) {
      throw Error('【设置分享】分享小程序时活动背景图片和按钮图片必须为http或者https协议');
    }

    extend(shareConfig, {
      imageUrl: info.miniProShareImg || info.img,
      // 分享图，在对话框内展示
      programName: VIP_MINIPTOGRAM_ID,
      miniProgramType: miniProgramType,
      path: "pages/activity/index?imgSrc=".concat(info.miniProImg, "&btnSrc=").concat(info.miniProBtn, "&url=").concat(encodeURIComponent(info.link || window.location.href)),
      isShareImageOnly: false // 如果设置 isShareImageOnly 则分享为小程序不生效

    });
  }

  return shareConfig;
}

var Share = {
  weixin: function weixin(info) {
    info = getShare2WeixinInfo(info);
    console.log('@@@@@Share2WeixinInfo:', info);
    TenvideoJSBridge.invoke('shareWeixinUser', info, function (ret) {
      console.log(ret);
    });
  },
  wxmoments: function wxmoments(info) {
    info = getVideoShareInfo(info);
    TenvideoJSBridge.invoke('shareWeixinTimeline', info, function () {
      console.log(ret);
    });
  },
  doki: function doki(info) {
    var _info = info,
        dokiUrlText = _info.dokiUrlText;
    info = getVideoShareInfo(info);

    if (info.isShareImageOnly) {
      TenvideoJSBridge.invoke('saveImage', {
        imgbase64String: info.imgbase64String,
        needSaveToAlbum: false
      }, function (res) {
        try {
          res = JSON.parse(res);
        } catch (e) {
          void 0;
        }

        if (res.result && res.result.filePath) {
          info.shareDokiInfo.shareImageInfo = {
            imgUrl: res.result.filePath,
            linkUrl: info.url,
            linkUrlText: dokiUrlText || info.singleTitle
          };
          info.shareDokiInfo.shareContent = info.singleTitle;
          delete info.shareDokiInfo.shareUrlInfo;
        }

        TenvideoJSBridge.invoke('shareDoki', info, function (ret) {
          console.log(ret);
        });
      });
    } else {
      TenvideoJSBridge.invoke('shareDoki', info, function (ret) {
        console.log(ret);
      });
    }
  },
  qq: function qq(info) {
    //shareQQUser
    info = getVideoShareInfo(info);
    TenvideoJSBridge.invoke('shareQQUser', info, function (ret) {
      console.log(ret);
    });
  },
  qzone: function qzone(info) {
    // shareQzone
    info = getVideoShareInfo(info);
    TenvideoJSBridge.invoke('shareQzone', info, function (ret) {
      console.log(ret);
    });
  },
  weibo: function weibo(info) {
    // shareSinaWeibo
    info = getVideoShareInfo(info, 'weibo');
    TenvideoJSBridge.invoke('shareSinaWeibo', info, function (ret) {
      console.log(ret);
    });
  }
};
export default {
  openShare: function openShare(type, shareInfo) {
    Share[type] && Share[type](shareInfo);
  }
};